import OpenPaymentLinkIcon from '../../../../../assets/icons/open-payment-link.svg?url';
import l from '../../../../../lang';
import ButtonCustom from '../../../../common/__deprecated__/button-custom';
import './styles.scss';
import { useEffect, useState } from 'react';
import { useDashboard } from '../../../../../store/dashboard';
import QRCode from 'react-qr-code';

const CreatedQRPay = () => {
  const [url, setUrl] = useState('');
  const { merchantMe, userMe } = useDashboard();

  useEffect(() => {
    const checkoutUrl = import.meta.env.REACT_APP_CHECKOUT_DOMAIN_DLGO;

    if (merchantMe) {
      const decryptedToken = `open_link:mid:${merchantMe.id}`;
      const paymentLink = `${checkoutUrl}/open-checkout/${btoa(decryptedToken)}?country=${merchantMe.country}`;
      setUrl(paymentLink);
    }
  }, [merchantMe]);

  const downloadQRCode = () => {
    const svg = document.querySelector('#qr-code');
    if (!svg) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const size = 1024;
    canvas.width = size;
    canvas.height = size;

    const img = new Image();

    img.onload = () => {
      ctx?.drawImage(img, 0, 0, size, size);

      const link = document.createElement('a');
      link.download = 'qr-code.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    };

    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgData)}`;
  };

  return (
    <div className="created_qr_payment_link">
      <img src={OpenPaymentLinkIcon} alt="QR Payment" />
      <h1>{l('qrPayment.title')}</h1>
      <div className="created_open_payment_link__subheadline">{l('qrPayment.subheadline')}</div>
      <div className="share_aff_link__link" style={{ margin: '20px 0', display: 'flex', justifyContent: 'center' }}>
        <div style={{ padding: '10px', border: 'solid 1px #ccc', borderRadius: '12px' }}>
          <QRCode id="qr-code" value={url} size={160} />
        </div>
      </div>
      <ButtonCustom onClick={downloadQRCode} variant="outlined" text={l('qrPayment.download')} />
      <div style={{ marginTop: '10px' }}>{l('qrPayment.description')}</div>
    </div>
  );
};

export default CreatedQRPay;
